var map = {
	"./Semaglutid-2.5mg.png": 11046,
	"./Semaglutide-.25mg.png": 26845,
	"./Semaglutide-.5mg.png": 2221,
	"./Semaglutide-1.75mg.png": 94051,
	"./Semaglutide-1mg.png": 71413,
	"./Semaglutide-2.5mg.png": 66821,
	"./Tirzepatide-10mg.png": 98232,
	"./Tirzepatide-12.5mg.png": 78981,
	"./Tirzepatide-15mg.png": 54553,
	"./Tirzepatide-2.5mg.png": 90002,
	"./Tirzepatide-5mg.png": 12034,
	"./Tirzepatide-7.5mg-p-500.png": 67002,
	"./Tirzepatide-7.5mg.png": 64279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76255;